export default __webpack_public_path__ + "static/media/O-007.5ac6906d.png";